export const config = {
  API_URL: "https://api.mysurface.in"  
};
